/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktoploginerror2Inputs */



/**
* | output |
* | --- |
* | "Sign-in could not be completed. Please try again." |
*
* @param {Desktoploginerror2Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const desktoploginerror2 = /** @type {((inputs?: Desktoploginerror2Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktoploginerror2Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("Sign-in could not be completed. Please try again.")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("La connexion a échoué. Veuillez réessayer.")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("無法完成登入，請重試。")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("로그인을 완료하지 못했습니다. 다시 시도해 주세요.")
	return /** @type {LocalizedString} */ ("ログインを完了できませんでした。もう一度お試しください。")
});
export { desktoploginerror2 as "desktopLoginError" }